/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Contact_FooterInputs */

const es_tyc_contact_footer = /** @type {(inputs: Tyc_Contact_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de entrada en vigor: 16 de marzo de 2026. Este documento se proporciona en espanol e ingles. En caso de discrepancia, prevalecera la version en ingles.`)
};

const en_tyc_contact_footer = /** @type {(inputs: Tyc_Contact_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effective date: March 16, 2026. This document is provided in Spanish and English. In case of discrepancy, the English version shall prevail.`)
};

/**
* | output |
* | --- |
* | "Effective date: March 16, 2026. This document is provided in Spanish and English. In case of discrepancy, the English version shall prevail." |
*
* @param {Tyc_Contact_FooterInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_contact_footer = /** @type {((inputs?: Tyc_Contact_FooterInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Contact_FooterInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_contact_footer(inputs)
	return en_tyc_contact_footer(inputs)
});
export { tyc_contact_footer as "tyc.contact.footer" }